module.exports = __webpack_public_path__ + "img/arrow.b0cb2505.svg";